import React, { useContext, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import { useAlert } from 'react-alert';
import { AUTH_EXCEPTIONS, verifyError, } from '../../../utils/verifyErrors';
import { Input } from '../../../components/Base/Elements';
import Base, { ContentContainer } from '../../../components/Base';
import { ButtonAppStore, Form, FormControl, InputErrorAppWeb, LinkBaseApp, SignInButtonsAppStore, } from '../../../assets/styles/GlobalStyles';
import { createCookie } from '../../../utils/cookies';
import { LogoAppWeb, } from "../../../components/Base/styled";
import { LoadingContext } from '../../../components/Loading/Loading.context';
import LogoImage from '../../../assets/images/logo-onfarm-box-login.png';
import { translate } from '../../../i18n/index';

const SignInAppStore = ({ history }) => {
    const alert = useAlert();
    const hasUsername = history.location.state ? history.location.state.username || '' : '';
    const hasPassword = history.location.state ? history.location.state.password || '' : '';
    const { showLoading, hideLoading } = useContext(LoadingContext);

    useEffect(() => {
        const logout = async () => {
            await Auth.signOut()
        }
        logout();
    }, []);

    const login = async (values) => {
        const response = await Auth.signIn(values.username.trim(), values.password.trim());

        if (response.challengeName === 'NEW_PASSWORD_REQUIRED') {
            return;
        }

        createCookie(response);

        history.push({
            pathname: '/selecionar-fazenda',
            search: history.location.search,
        });
        hideLoading();
        return;
    }

    return (
        <Base width={430} marginTop="450" isAppWeb={false} isStore={true} isImilk={false} backgroundForm={'#FFF'}>
            <ContentContainer>

                <LogoAppWeb src={LogoImage} alt="Logo do site" title="OnFarm" />

                <Formik
                    enableReinitialize
                    initialValues={{
                        username: hasUsername,
                        password: hasPassword,
                    }}
                    validationSchema={Yup.object().shape({
                        username: Yup.string().required(translate('validateRequired')),
                        password: Yup.string().required(translate('validateRequired')),
                    })}
                    onSubmit={async (values, actions) => {
                        if (values) {
                            showLoading();
                            try {
                                await login(values);
                            } catch (e) {
                                console.log('ERROR LOGIN store:  ', e)

                                if (e.code === 'UserNotConfirmedException' && e.message === AUTH_EXCEPTIONS.USER_NOT_CONFIRMED) {
                                    console.log('ERROR LOGIN:  ', e)
                                    history.push({
                                        pathname: '/confirmar',
                                        search: history.location.search,
                                        state: {
                                            username: values.username.trim(),
                                            password: values.password
                                        },
                                    })
                                    hideLoading();
                                    return;
                                }

                                alert.show(<span style={{ backgroundColor: 'white', color: 'black', display: 'flex', flexDirection: 'column', padding: '10px', borderRadius: '5px' }}>
                                    <p>{verifyError(e.code, e.message, true)}</p>
                                    <a href="https://store.onfarm.com.br/" target="blank">store.onfarm.com.br</a>
                                </span>, {
                                    closeCopy: 'Fechar',
                                    onClose: () => {
                                        if (e.code === 'UserNotFoundException' && e.message.includes(AUTH_EXCEPTIONS.MISSING_EMAIL_AND_CELLPHONE)) {

                                        }
                                    },
                                });
                            }

                            hideLoading();
                        }
                        actions.setSubmitting(false);
                    }}>
                    {({ isSubmitting }) => (

                        <Form>
                            <>
                                <FormControl>
                                    <Field
                                        autocapitalize="off"
                                        isAppWeb={true}
                                        name="username"
                                        placeholder={translate('labelDigiteNomeUsuario')}
                                        component={Input}
                                    />
                                    <ErrorMessage name="username" component={InputErrorAppWeb} />
                                </FormControl>

                                <FormControl>
                                    <Field
                                        type="password"
                                        name="password"
                                        isAppWeb={true}
                                        placeholder={translate('labelDigiteSenha')}
                                        component={Input}
                                    />
                                    <ErrorMessage name="password" component={InputErrorAppWeb} />
                                </FormControl>

                                <FormControl style={{ display: 'flex', marginTop: 50 }}>
                                    <LinkBaseApp
                                        to={{
                                            pathname: '/esqueci-minha-senha',
                                            search: history.location.search,
                                        }}>
                                        {translate('loginResetPassword')}
                                    </LinkBaseApp>
                                    <SignInButtonsAppStore>
                                        <ButtonAppStore type="submit" disabled={isSubmitting}>
                                            {isSubmitting ? translate('buttonEntering') : translate('buttonEnter')}
                                        </ButtonAppStore>
                                    </SignInButtonsAppStore>
                                </FormControl>

                                <FormControl style={{ margin: '20px 0' }}>
                                    <LinkBaseApp
                                        to={{
                                            pathname: '/cadastre-se',
                                            search: history.location.search,
                                        }}>
                                        {translate('loginColumnLeftTitle')}
                                    </LinkBaseApp>
                                </FormControl>
                            </>
                        </Form>
                    )}
                </Formik>
            </ContentContainer>
        </Base>
    )

}

export default SignInAppStore
